import { useState, useCallback, useMemo } from 'react';

export const useCreateRowSelection = ({ cellWidth, data, rowKey = 'id' }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleSelectRows = useCallback(
    (rows) => setSelectedRowKeys(rows.map((row) => row[rowKey])),
    [rowKey]
  );

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onSelect: (_record, _selected, rows) => handleSelectRows(rows),
      onSelectAll: (selected) => handleSelectRows(selected ? data : []),
      columnWidth: cellWidth,
    }),
    [selectedRowKeys, handleSelectRows, data, cellWidth]
  );

  return rowSelection;
};
